import { createContext } from 'react';

export type RootContextType = {
  reminderVisible: boolean;
  reminderToggle: (visible: boolean) => void;
  navVisible: boolean;
  setNavVisibility: React.Dispatch<React.SetStateAction<boolean>>;
};

export const defaultRootContext: RootContextType = {
  reminderVisible: false,
  reminderToggle: () => {
    throw 'Missing root context provider in tree';
  },
  navVisible: true,
  setNavVisibility: () => {
    throw 'Missing root context provider in tree';
  },
};

export const RootContext = createContext(defaultRootContext);
